import {Storage} from '@ionic/storage';

const persist = new Storage({});
persist.create();

export default persist;
